import {
  MdAdd,
  MdExpandMore,
  MdChevronRight,
  MdSearch,
  MdPhone,
  MdEmail,
  MdDashboard,
  MdHome,
  MdPerson,
  MdExitToApp,
  MdNotifications,
  MdEvent,
  MdFavorite,
  MdFavoriteBorder,
  MdDelete,
  MdMenu,
  MdEdit,
  MdNotificationsOff,
  MdMoreHoriz,
  MdClose,
  MdHotel,
  MdLaunch,
  MdWarning,
  MdPlayCircleFilled,
  MdVisibility,
  MdVisibilityOff,
  MdMoreVert
} from 'react-icons/md';
import {
  FaBath,
  FaCouch,
  FaFacebook,
  FaGithub,
  FaGoogle,
} from 'react-icons/fa';

export const StarberryIcons = {
  leftIcon: MdMoreHoriz,
  rightIcon: MdMoreVert,
  add: MdAdd,
  'chevron-down': MdExpandMore,
  'chevron-right': MdChevronRight,
  search: MdSearch,
  home: MdHome,
  phone: MdPhone,
  email: MdEmail,
  dashboard: MdDashboard,
  profile: MdPerson,
  logout: MdExitToApp,
  notification: MdNotifications,
  calendar: MdEvent,
  saveProperty: MdFavorite,
  savePropertyEmpty: MdFavoriteBorder,
  savePropertyDelete: MdClose,
  saveSearchEmpty: MdSearch,
  saveSearchAction: MdSearch,
  saveSearchDelete: MdDelete,
  saveSearchViewResults: MdMenu,
  saveSearchEdit: MdEdit,
  saveSearchStopAlerts: MdNotificationsOff,
  moreActions: MdMoreHoriz,
  bedroom: MdHotel,
  bathroom: FaBath,
  reception: FaCouch,
  backToWebsite: MdLaunch,
  errorPage: MdWarning,
  videoPlay: MdPlayCircleFilled,
  emailInput: MdEmail,
  emailPassShow: MdVisibility,
  emailPassHide: MdVisibilityOff,
  loginFacebook: FaFacebook,
  loginGoogle: FaGoogle,
  loginGithub: FaGithub,
};
